import { Component, OnInit } from '@angular/core';
import { SsoAuthService } from 'src/app/ecan/sso-auth.service';
import { AppConfigurationService } from 'src/app/stp/stp-app/common';

@Component({
  selector: 'app-auditor-role-required',
  templateUrl: './auditor-role-required.component.html'
})
export class AuditorRoleRequiredComponent implements OnInit {

  constructor(private ssoAuthService: SsoAuthService,
    private appConfig: AppConfigurationService) { }

  ngOnInit() {
  }

  public logout() {
    this.ssoAuthService.logout(this.appConfig.getValue('webUrl') + '/login');
  }
}
